// Copyright (c) 2026 Celadonsoft
// All rights reserved.

// scripts/prerender.js sets this via page.evaluateOnNewDocument() before any
// app script runs, so it's readable from the very first tick - including
// inside a component's data() where swiperOptions gets built.
export function isPrerender() {
  return typeof window !== 'undefined' && window.__PRERENDER__ === true;
}
